<script setup lang="ts">
interface Option {
  id: string | number
  value: string | number | boolean
  label: string
}
defineProps({
  label: {
    type: String,
    default: '',
  },
  options: {
    type: Array as () => Option[],
    required: true,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const modelValue = defineModel<string | number | boolean | null>()
</script>

<template>
  <label class="form-control w-full">
    <div class="label">
      <span class="label-text font-semibold">
        {{ label }}
        <span v-if="required" class="text-red-500">*</span>
      </span>
    </div>

    <select
      id="select-component"
      v-model="modelValue"
      class="select select-bordered select-sm w-full"
      :class="{ 'border-red-500': errorMessage }"
      :disabled="disabled"
    >
      <option v-for="option in options" :key="option.id" :id="String(option.id)" :value="option.value">
        {{ option.label }}
      </option>
    </select>

    <span v-if="errorMessage" class="text-red-500 text-sm">{{ errorMessage }}</span>
  </label>
</template>
